import type { Props } from './Svg'
import { Svg } from './Svg'

export function ClockIcon(props: Props) {
  return (
    <Svg width="16" height="16" fill="currentColor" stroke="none" {...props}>
      <path d="M8.4 4H7.2v4.8l4.2 2.5.6-1-3.6-2.1V4ZM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 14.4A6.4 6.4 0 1 1 8 1.6a6.4 6.4 0 0 1 0 12.8Z" />
    </Svg>
  )
}
